import React from 'react'
import { PlasmicComponent } from '@plasmicapp/loader-react'
import { Box } from '@plvs/respawn/features/layout/Box'
import { NxButton } from '@playvs-inc/nexus-components'
import { useFlags } from 'launchdarkly-react-client-sdk'

export const PlayvsCollective: React.FC = () => {
  const [isExpanded, setIsExpanded] = React.useState(false)

  const flags = useFlags()

  const shouldShowMore = flags?.collectiveShowMore

  return (
    <Box mt={3}>
      <PlasmicComponent component="PlayVsCollective" />
      {shouldShowMore && (
        <>
          {isExpanded && (
            <div data-testid="collective-more">
              <PlasmicComponent
                component="PlayVSCollectiveMore"
                data-testid="test"
              />
            </div>
          )}
          <Box
            alignItems="center"
            display="flex"
            justifyContent="center"
            mt={2}
          >
            <NxButton
              data-testid="collective-show-more"
              label={
                isExpanded
                  ? 'View Less Collective Partners'
                  : 'View All Collective Partners'
              }
              onClick={(): void => setIsExpanded(!isExpanded)}
              variant="secondary"
            />
          </Box>
        </>
      )}
    </Box>
  )
}
